var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "image / 29 - image, brightness, sun, sunny, weather icon"), /*#__PURE__*/React.createElement("g", {
    id: "Free-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-451.000000, -526.000000)",
    id: "Group",
    stroke: "#3576bb",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(449.000000, 524.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,15.5 C10.0670034,15.5 8.5,13.9329966 8.5,12 C8.5,10.0670034 10.0670034,8.5 12,8.5 C13.9329966,8.5 15.5,10.0670034 15.5,12 C15.5,13.9329966 13.9329966,15.5 12,15.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.3016885,
    y1: 17.0538957,
    x2: 5.88747494,
    y2: 18.4681092
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.3016885,
    y1: 7.15440072,
    x2: 5.88747494,
    y2: 5.74018716
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.615397,
    y1: 18.4681092,
    x2: 17.2011834,
    y2: 17.0538957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.615397,
    y1: 5.74018716,
    x2: 17.2011834,
    y2: 7.15440072
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sunIcon.c639241b54a657af2e79db9603506b58.svg";
export { ForwardRef as ReactComponent };